import React from 'react';
import { HistoryLocation, useLocation } from '@reach/router';

let history: Record<string, HistoryLocation> = {};

export const useHistoryListener = (): void => {
  const location = useLocation();
  React.useEffect(() => {
    const pathname = location.pathname.replace(/\/$/, '');
    history = {
      ...history,
      [pathname]: location,
    };
  }, [location]);
};

export const useHistoryPath = (path: string): HistoryLocation | undefined => {
  return history[path];
};
